export const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;
// export const baseUrl = "http://localhost:4001/api/";
